@if (loading) {
    <kendo-loader></kendo-loader>
}
@else if (loadingFailed) {
    <div class="loading-failed">
        <span class="fa-solid fa-exclamation-triangle"></span>
        <span>Failed to load instance.</span>
     </div>
}
<!-- below we use style/display:none so that the component is always in existence -->
<skip-chat 
    #skipChat
    [style]="loading || loadingFailed ? { display: 'none' } : {}" 
    class="skip-chat"
    [AutoLoad]="false"
    [ShowDataContextButton]="false"
    mjFillContainer
    (NavigateToMatchingReport)="showReport($event)"
    (NewReportCreated)="onNewReportCreated($event)"
    (ConversationSelected)="onConversationSelected($event)"
    [UpdateAppRoute]="false"
    SkipLogoURL="/assets/images/Skip Full Logo - Transparent.png"
    SkipMarkOnlyLogoURL="/assets/images/Skip - Mark Only - Small.png"

    mjFillContainer
    [fillHeight]="true"
    [fillWidth]="false"
>
</skip-chat>
